import React, { useState } from "react";
import './sustentable.css';

const Sustentable = ({titulo}) => {
    const [isPIMUSCollapsed, setIsPIMUSCollapsed] = useState(true);
  const [subMenu1Collapsed, setSubMenu1Collapsed] = useState(true);
  const [isTRAMITESCollapsed, setIsTRAMITESCollapsed] = useState(true);
  const [subMenu2Collapsed, setSubMenu2Collapsed] = useState(true);
  const [subMenu3Collapsed, setSubMenu3Collapsed] = useState(true);
  const [isCICLOCollapsed, setIsCICLOCollapsed] = useState(true);
  const [subMenu4Collapsed, setSubMenu4Collapsed] = useState(true);
      return(
        <div className="container container-mh">
            <div className="title">
            <h1> Dirección General de Movilidad Sustentable</h1>
            <br></br>
            <hr className="hr-gob" />
            <h5>Movilidad Urbana Sustentable</h5>
            <br></br>
            <div className="row">
            
              <div className="contenido-button-group">
                <button 
                  className="btn btn-primary contenido-button"
                  type="button"
                  onClick={() => setIsPIMUSCollapsed(!isPIMUSCollapsed)}
                  aria-expanded={!isPIMUSCollapsed}
                >
                  PIMUS
                </button>
                <p></p>
                <div className={`multi-collapse collapse ${isPIMUSCollapsed ? '' : 'show'}`} id="pimus-menu">
                  <button
                    className="btn btn-primary contenido-button"
                    type="button"
                    onClick={() => setSubMenu1Collapsed(!subMenu1Collapsed)}
                    aria-expanded={!subMenu1Collapsed}
                  >
                    1.- Plan Integral de Movilidad Urbana Sustentable
                  </button>
                  <p></p>
                  <div className={`multi-collapse armo-collapse collapse ${subMenu1Collapsed ? '' : 'show'}`} id="lista-0-0">
                    <a
                      href="../assets/PDF/PIMUS ZMPACHUCA-VERSION EJECUTIVA.pdf"
                      target="_blank"
                      className="btn btn-primary btn-armo-collapse btn-dorado"
                    >
                      1.1 Zona Metropolitana de Pachuca de Soto, Hidalgo
                    </a>
                    <br></br>
                    <p></p>
                    <a
                      href="../assets/PDF/PIMUS ZM TULANCINGO-VERSION EJECUTIVA.pdf"
                      target="_blank"
                      className="btn btn-primary btn-armo-collapse btn-dorado"
                    >
                      1.2 Zona Metropolitana de Tulancingo de Bravo, Hidalgo
                    </a>
                    <br></br>
                    <p></p>
                    <a
                      href="../assets/PDF/PIMUS ZMTULA-VERSION EJECUTIVA.pdf"
                      target="_blank"
                      className="btn btn-primary btn-armo-collapse btn-dorado"
                    >
                      1.3 Zona Metropolitana de Tula de Allende, Hidalgo
                    </a>
                  </div>
                  <p></p>
           </div>
          </div>
           </div>  
           <p></p>
           <br></br>
           <h5>Tramites de la Secretaría de Movilidad y Transporte</h5>
           <br></br>
           <p></p>
            <div className="row">
           
              <div className="contenido-button-group">
                <button 
                  className="btn btn-primary contenido-button"
                  type="button"
                  onClick={() => setIsTRAMITESCollapsed(!isTRAMITESCollapsed)}
                  aria-expanded={!isTRAMITESCollapsed}
                >
                  TRAMITES
                </button>
                <p></p>
                <div className={`multi-collapse collapse ${isTRAMITESCollapsed ? '' : 'show'}`} id="TRAMITES-menu">
                  <button
                    className="btn btn-primary contenido-button"
                    type="button"
                    onClick={() => setSubMenu2Collapsed(!subMenu2Collapsed)}
                    aria-expanded={!subMenu2Collapsed}
                  >
                    2.- Dictamen de impacto en la movilidad
                  </button>
                  <p></p>
                  <div className={`multi-collapse armo-collapse collapse ${subMenu2Collapsed ? '' : 'show'}`} id="lista-0-0">
                    <a
                      href="https://ruts.hidalgo.gob.mx/ver/11393"
                      target="_blank"
                      rel="noreferrer"
                      className="btn btn-primary btn-armo-collapse btn-dorado"
                    >
                      Ir a tramite en RUTS
                    </a>
                    </div>
                    <p></p>
                    <button
                    className="btn btn-primary contenido-button"
                    type="button"
                    onClick={() => setSubMenu3Collapsed(!subMenu3Collapsed)}
                    aria-expanded={!subMenu3Collapsed}
                  >
                    3.- Registro de personas y profesionistas para expedir el estudio de Impacto a la Movilidad
                  </button>
                  <p></p>
                  <div className={`multi-collapse armo-collapse collapse ${subMenu3Collapsed ? '' : 'show'}`} id="lista-0-0">
                    <a
                      href="https://ruts.hidalgo.gob.mx/ver/9914"
                      target="_blank"
                      rel="noreferrer"
                      className="btn btn-primary btn-armo-collapse btn-dorado"
                    >
                      Ir a tramite en RUTS
                    </a>
                    </div>
                </div>
                </div>  
                </div>
                <br></br>
                <h5>Padrón Estatal de Ciclovías</h5> 
                <br></br>
                <div className="row">
              <div className="contenido-button-group">
                <button 
                  className="btn btn-primary contenido-button"
                  type="button"
                  onClick={() => setIsCICLOCollapsed(!isCICLOCollapsed)}
                  aria-expanded={!isCICLOCollapsed}
                >
                  CICLOVÍAS
                </button>
                <p></p>
                <div className={`multi-collapse collapse ${isCICLOCollapsed ? '' : 'show'}`} id="CICLO-menu">
                  <button
                    className="btn btn-primary contenido-button"
                    type="button"
                    onClick={() => setSubMenu4Collapsed(!subMenu4Collapsed)}
                    aria-expanded={!subMenu4Collapsed}
                  >
                    4.- Padrón 2025
                  </button>
                  <p></p>
                  <div className={`multi-collapse armo-collapse collapse ${subMenu4Collapsed ? '' : 'show'}`} id="lista-0-0">
                    <a
                      href="../assets/PDF/PEC_2025.pdf"
                      target="_blank"
                      rel="noreferrer"
                      className="btn btn-primary btn-armo-collapse btn-dorado"
                    >
                      Descargar
                    </a>
                   </div>
                  </div>
                </div>
               </div>
              <br></br>
            </div>
          </div>
   )
}
export default Sustentable